import React from "react";

import ExclusiveMembership from "./ExclusiveMembership";
import GrowBusiness from "./GrowBusiness";
import BuildNetwork from "./BuildNetwork";

import { Paper, Typography, Divider } from "@mui/material";

const Headline = () => {
  return (
    <Paper
      elevation={20}
      sx={{ padding: { xs: "2rem", md: "4rem" }, mt: "6rem", borderRadius: 5 }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          color: "secondary.main",
          mb: "1rem",
        }}
      >
        OUR MEMBERSHIP
      </Typography>
      <Typography
        variant="h4"
        component="h2"
        sx={{
          fontWeight: "bold",
          maxWidth: { xs: "100%", sm: "70%" },
          textAlign: "center",
          mx: "auto",
        }}
      >
        We help our SaaS Founders make decisions with more clarity.
      </Typography>
      <Typography variant="body1" sx={{ mt: "1.2rem", textAlign: "center" }}>
        Connect to a network of successful founders through masterminds. Build a
        personal board of peer-advisors. Unlock access to prominent business
        experts. Find success as a SaaS Founder.
      </Typography>
      <ExclusiveMembership />
      <Divider variant="middle" />
      <GrowBusiness />
      <Divider variant="middle" />
      <BuildNetwork />
    </Paper>
  );
};

export default Headline;
